<div [@growIn]="notification.disableEntryAnimation ? 'void' : 'growIn'">
    <mat-card
        [@fadeOut]="expired && !notification.disableExitAnimation ? 'expired' : 'default'"
        [appearance]="'outlined'"
        [class]="'!tw-bg-lendio-cool-gray-800 lendio-stackable-notification-card !tw-p-4'">
        <div class="column-grid tw-text-white tw-justify-between">
            <div class="column-grid tw-gap-4">
                <div *ngIf="!!notification.badge"
                     class="tw-h-12 tw-w-12 tw-rounded-full column-grid tw-justify-center tw-place-items-center {{ notification.badge.class || 'tw-bg-lendio-warm-gray-400' }}">
                    <ng-container [ngSwitch]="notification.badge.type">
                        <ng-container *ngSwitchCase="'icon'">
                            <mat-icon [class]="notification.badge.iconClass">{{ notification.badge.value || 'check' }}</mat-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="'simple'">
                            <div class="tw-line-normal {{ notification.badge.textClass }}">{{ notification.badge.value }}</div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'image'">
                            <img class="{{ notification.badge.imageClass }}" [src]="notification.badge.value">
                        </ng-container>

                        <ng-container *ngSwitchDefault></ng-container>
                    </ng-container>
                </div>
                <div class="tw-grid tw-text-sm" [ngClass]="{'tw-h-min':!!notification.title}">
                    <div class="tw-h-min tw-font-semibold">{{ notification.title }}</div>
                    <div *ngIf="!!notification.progress && notification.progress >= 0" class="pr-4 py-2">
                        <mat-progress-bar mode="determinate" [value]="notification.progress"></mat-progress-bar>
                    </div>
                    <div class="tw-font-normal tw-align-middle">
                        {{ notification.subTitle }}
                    </div>
                </div>
            </div>
            <div *appLet="(notification.action?.label?.length >= 10) as longAction"
                 class="lendio-density-1 tw-grid tw-justify-items-end tw-h-min"
                 [ngClass]="{
                    'tw-grid-flow-col': !longAction || !notification.dismissible,
                    'tw-gap-2': !longAction,
                }">
                <button *ngIf="!!notification.action"
                        mat-button
                        class="!tw-text-white {{ longAction ? 'tw-row-start-2' : '' }}"
                        (click)="handleAction()">
                    {{ notification.action.label }}
                </button>
                <button *ngIf="notification.dismissible" mat-icon-button (click)="clearNotification()">
                    <mat-icon class="!tw-text-lendio-cool-gray-500">close</mat-icon>
                </button>
            </div>
        </div>
    </mat-card>
</div>
